var endpointMap = {
	am: {
		"pages.homepage": "translation-am.json",
		"pages.nav": "translation-am.json",
		"pages.notfound": "translation-am.json",
		"pages.optin": "translation-am.json",
		"pages.unsubscribe": "translation-am.json"
	},
	"am-ET": {
		"pages.homepage": "translation-am.json",
		"pages.nav": "translation-am.json",
		"pages.notfound": "translation-am.json",
		"pages.optin": "translation-am.json",
		"pages.unsubscribe": "translation-am.json"
	},
	ar: {
		"pages.homepage": "translation-ar.json",
		"pages.nav": "translation-ar.json",
		"pages.notfound": "translation-ar.json",
		"pages.optin": "translation-ar.json",
		"pages.unsubscribe": "translation-ar.json"
	},
	"ar-SA": {
		"pages.homepage": "translation-ar.json",
		"pages.nav": "translation-ar.json",
		"pages.notfound": "translation-ar.json",
		"pages.optin": "translation-ar.json",
		"pages.unsubscribe": "translation-ar.json"
	},
	bn: {
		"pages.homepage": "translation-bn.json",
		"pages.nav": "translation-bn.json",
		"pages.notfound": "translation-bn.json",
		"pages.optin": "translation-bn.json",
		"pages.unsubscribe": "translation-bn.json"
	},
	"bn-IN": {
		"pages.homepage": "translation-bn.json",
		"pages.nav": "translation-bn.json",
		"pages.notfound": "translation-bn.json",
		"pages.optin": "translation-bn.json",
		"pages.unsubscribe": "translation-bn.json"
	},
	cs: {
		"pages.homepage": "translation-cs.json",
		"pages.nav": "translation-cs.json",
		"pages.notfound": "translation-cs.json",
		"pages.optin": "translation-cs.json",
		"pages.unsubscribe": "translation-cs.json"
	},
	"cs-CZ": {
		"pages.homepage": "translation-cs.json",
		"pages.nav": "translation-cs.json",
		"pages.notfound": "translation-cs.json",
		"pages.optin": "translation-cs.json",
		"pages.unsubscribe": "translation-cs.json"
	},
	de: {
		"pages.homepage": "translation-de.json",
		"pages.nav": "translation-de.json",
		"pages.notfound": "translation-de.json",
		"pages.optin": "translation-de.json",
		"pages.unsubscribe": "translation-de.json"
	},
	"de-DE": {
		"pages.homepage": "translation-de.json",
		"pages.nav": "translation-de.json",
		"pages.notfound": "translation-de.json",
		"pages.optin": "translation-de.json",
		"pages.unsubscribe": "translation-de.json"
	},
	en: {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json",
		"pages.notfound": "translation-en.json",
		"pages.optin": "translation-en.json",
		"pages.unsubscribe": "translation-en.json"
	},
	"en-CA": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json",
		"pages.notfound": "translation-en.json",
		"pages.optin": "translation-en.json",
		"pages.unsubscribe": "translation-en.json"
	},
	"en-GB": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json",
		"pages.notfound": "translation-en.json",
		"pages.optin": "translation-en.json",
		"pages.unsubscribe": "translation-en.json"
	},
	"en-IN": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json",
		"pages.notfound": "translation-en.json",
		"pages.optin": "translation-en.json",
		"pages.unsubscribe": "translation-en.json"
	},
	"en-US": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json",
		"pages.notfound": "translation-en.json",
		"pages.optin": "translation-en.json",
		"pages.unsubscribe": "translation-en.json"
	},
	es: {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json",
		"pages.notfound": "translation-es.json",
		"pages.optin": "translation-es.json",
		"pages.unsubscribe": "translation-es.json"
	},
	"es-ES": {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json",
		"pages.notfound": "translation-es.json",
		"pages.optin": "translation-es.json",
		"pages.unsubscribe": "translation-es.json"
	},
	"es-MX": {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json",
		"pages.notfound": "translation-es.json",
		"pages.optin": "translation-es.json",
		"pages.unsubscribe": "translation-es.json"
	},
	fa: {
		"pages.homepage": "translation-fa.json",
		"pages.nav": "translation-fa.json",
		"pages.notfound": "translation-fa.json",
		"pages.optin": "translation-fa.json",
		"pages.unsubscribe": "translation-fa.json"
	},
	"fa-AF": {
		"pages.homepage": "translation-fa.json",
		"pages.nav": "translation-fa.json",
		"pages.notfound": "translation-fa.json",
		"pages.optin": "translation-fa.json",
		"pages.unsubscribe": "translation-fa.json"
	},
	fil: {
		"pages.homepage": "translation-fil.json",
		"pages.nav": "translation-fil.json",
		"pages.notfound": "translation-fil.json",
		"pages.optin": "translation-fil.json",
		"pages.unsubscribe": "translation-fil.json"
	},
	fr: {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json",
		"pages.notfound": "translation-fr.json",
		"pages.optin": "translation-fr.json",
		"pages.unsubscribe": "translation-fr.json"
	},
	"fr-CA": {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json",
		"pages.notfound": "translation-fr.json",
		"pages.optin": "translation-fr.json",
		"pages.unsubscribe": "translation-fr.json"
	},
	"fr-FR": {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json",
		"pages.notfound": "translation-fr.json",
		"pages.optin": "translation-fr.json",
		"pages.unsubscribe": "translation-fr.json"
	},
	gu: {
		"pages.homepage": "translation-gu.json",
		"pages.nav": "translation-gu.json",
		"pages.notfound": "translation-gu.json",
		"pages.optin": "translation-gu.json",
		"pages.unsubscribe": "translation-gu.json"
	},
	"gu-IN": {
		"pages.homepage": "translation-gu.json",
		"pages.nav": "translation-gu.json",
		"pages.notfound": "translation-gu.json",
		"pages.optin": "translation-gu.json",
		"pages.unsubscribe": "translation-gu.json"
	},
	hi: {
		"pages.homepage": "translation-hi.json",
		"pages.nav": "translation-hi.json",
		"pages.notfound": "translation-hi.json",
		"pages.optin": "translation-hi.json",
		"pages.unsubscribe": "translation-hi.json"
	},
	"hi-IN": {
		"pages.homepage": "translation-hi.json",
		"pages.nav": "translation-hi.json",
		"pages.notfound": "translation-hi.json",
		"pages.optin": "translation-hi.json",
		"pages.unsubscribe": "translation-hi.json"
	},
	ht: {
		"pages.homepage": "translation-ht.json",
		"pages.nav": "translation-ht.json",
		"pages.notfound": "translation-ht.json",
		"pages.optin": "translation-ht.json",
		"pages.unsubscribe": "translation-ht.json"
	},
	"ht-HT": {
		"pages.homepage": "translation-ht.json",
		"pages.nav": "translation-ht.json",
		"pages.notfound": "translation-ht.json",
		"pages.optin": "translation-ht.json",
		"pages.unsubscribe": "translation-ht.json"
	},
	id: {
		"pages.homepage": "translation-id.json",
		"pages.nav": "translation-id.json",
		"pages.notfound": "translation-id.json",
		"pages.optin": "translation-id.json",
		"pages.unsubscribe": "translation-id.json"
	},
	"id-ID": {
		"pages.homepage": "translation-id.json",
		"pages.nav": "translation-id.json",
		"pages.notfound": "translation-id.json",
		"pages.optin": "translation-id.json",
		"pages.unsubscribe": "translation-id.json"
	},
	it: {
		"pages.homepage": "translation-it.json",
		"pages.nav": "translation-it.json",
		"pages.notfound": "translation-it.json",
		"pages.optin": "translation-it.json",
		"pages.unsubscribe": "translation-it.json"
	},
	"it-IT": {
		"pages.homepage": "translation-it.json",
		"pages.nav": "translation-it.json",
		"pages.notfound": "translation-it.json",
		"pages.optin": "translation-it.json",
		"pages.unsubscribe": "translation-it.json"
	},
	ja: {
		"pages.homepage": "translation-ja.json",
		"pages.nav": "translation-ja.json",
		"pages.notfound": "translation-ja.json",
		"pages.optin": "translation-ja.json",
		"pages.unsubscribe": "translation-ja.json"
	},
	"ja-JP": {
		"pages.homepage": "translation-ja.json",
		"pages.nav": "translation-ja.json",
		"pages.notfound": "translation-ja.json",
		"pages.optin": "translation-ja.json",
		"pages.unsubscribe": "translation-ja.json"
	},
	ko: {
		"pages.homepage": "translation-ko.json",
		"pages.nav": "translation-ko.json",
		"pages.notfound": "translation-ko.json",
		"pages.optin": "translation-ko.json",
		"pages.unsubscribe": "translation-ko.json"
	},
	"ko-KR": {
		"pages.homepage": "translation-ko.json",
		"pages.nav": "translation-ko.json",
		"pages.notfound": "translation-ko.json",
		"pages.optin": "translation-ko.json",
		"pages.unsubscribe": "translation-ko.json"
	},
	ne: {
		"pages.homepage": "translation-ne.json",
		"pages.nav": "translation-ne.json",
		"pages.notfound": "translation-ne.json",
		"pages.optin": "translation-ne.json",
		"pages.unsubscribe": "translation-ne.json"
	},
	"ne-NP": {
		"pages.homepage": "translation-ne.json",
		"pages.nav": "translation-ne.json",
		"pages.notfound": "translation-ne.json",
		"pages.optin": "translation-ne.json",
		"pages.unsubscribe": "translation-ne.json"
	},
	nl: {
		"pages.homepage": "translation-nl.json",
		"pages.nav": "translation-nl.json",
		"pages.notfound": "translation-nl.json",
		"pages.optin": "translation-nl.json",
		"pages.unsubscribe": "translation-nl.json"
	},
	"nl-NL": {
		"pages.homepage": "translation-nl.json",
		"pages.nav": "translation-nl.json",
		"pages.notfound": "translation-nl.json",
		"pages.optin": "translation-nl.json",
		"pages.unsubscribe": "translation-nl.json"
	},
	pa: {
		"pages.homepage": "translation-pa.json",
		"pages.nav": "translation-pa.json",
		"pages.notfound": "translation-pa.json",
		"pages.optin": "translation-pa.json",
		"pages.unsubscribe": "translation-pa.json"
	},
	"pa-IN": {
		"pages.homepage": "translation-pa.json",
		"pages.nav": "translation-pa.json",
		"pages.notfound": "translation-pa.json",
		"pages.optin": "translation-pa.json",
		"pages.unsubscribe": "translation-pa.json"
	},
	pl: {
		"pages.homepage": "translation-pl.json",
		"pages.nav": "translation-pl.json",
		"pages.notfound": "translation-pl.json",
		"pages.optin": "translation-pl.json",
		"pages.unsubscribe": "translation-pl.json"
	},
	"pl-PL": {
		"pages.homepage": "translation-pl.json",
		"pages.nav": "translation-pl.json",
		"pages.notfound": "translation-pl.json",
		"pages.optin": "translation-pl.json",
		"pages.unsubscribe": "translation-pl.json"
	},
	pt: {
		"pages.homepage": "translation-pt.json",
		"pages.nav": "translation-pt.json",
		"pages.notfound": "translation-pt.json",
		"pages.optin": "translation-pt.json",
		"pages.unsubscribe": "translation-pt.json"
	},
	"pt-BR": {
		"pages.homepage": "translation-pt.json",
		"pages.nav": "translation-pt.json",
		"pages.notfound": "translation-pt.json",
		"pages.optin": "translation-pt.json",
		"pages.unsubscribe": "translation-pt.json"
	},
	ro: {
		"pages.homepage": "translation-ro.json",
		"pages.nav": "translation-ro.json",
		"pages.notfound": "translation-ro.json",
		"pages.optin": "translation-ro.json",
		"pages.unsubscribe": "translation-ro.json"
	},
	"ro-RO": {
		"pages.homepage": "translation-ro.json",
		"pages.nav": "translation-ro.json",
		"pages.notfound": "translation-ro.json",
		"pages.optin": "translation-ro.json",
		"pages.unsubscribe": "translation-ro.json"
	},
	ru: {
		"pages.homepage": "translation-ru.json",
		"pages.nav": "translation-ru.json",
		"pages.notfound": "translation-ru.json",
		"pages.optin": "translation-ru.json",
		"pages.unsubscribe": "translation-ru.json"
	},
	"ru-RU": {
		"pages.homepage": "translation-ru.json",
		"pages.nav": "translation-ru.json",
		"pages.notfound": "translation-ru.json",
		"pages.optin": "translation-ru.json",
		"pages.unsubscribe": "translation-ru.json"
	},
	rw: {
		"pages.homepage": "translation-rw.json",
		"pages.nav": "translation-rw.json",
		"pages.notfound": "translation-rw.json",
		"pages.optin": "translation-rw.json",
		"pages.unsubscribe": "translation-rw.json"
	},
	"rw-RW": {
		"pages.homepage": "translation-rw.json",
		"pages.nav": "translation-rw.json",
		"pages.notfound": "translation-rw.json",
		"pages.optin": "translation-rw.json",
		"pages.unsubscribe": "translation-rw.json"
	},
	sk: {
		"pages.homepage": "translation-sk.json",
		"pages.nav": "translation-sk.json",
		"pages.notfound": "translation-sk.json",
		"pages.optin": "translation-sk.json",
		"pages.unsubscribe": "translation-sk.json"
	},
	"sk-SK": {
		"pages.homepage": "translation-sk.json",
		"pages.nav": "translation-sk.json",
		"pages.notfound": "translation-sk.json",
		"pages.optin": "translation-sk.json",
		"pages.unsubscribe": "translation-sk.json"
	},
	so: {
		"pages.homepage": "translation-so.json",
		"pages.nav": "translation-so.json",
		"pages.notfound": "translation-so.json",
		"pages.optin": "translation-so.json",
		"pages.unsubscribe": "translation-so.json"
	},
	"so-SO": {
		"pages.homepage": "translation-so.json",
		"pages.nav": "translation-so.json",
		"pages.notfound": "translation-so.json",
		"pages.optin": "translation-so.json",
		"pages.unsubscribe": "translation-so.json"
	},
	sw: {
		"pages.homepage": "translation-sw.json",
		"pages.nav": "translation-sw.json",
		"pages.notfound": "translation-sw.json",
		"pages.optin": "translation-sw.json",
		"pages.unsubscribe": "translation-sw.json"
	},
	"sw-KE": {
		"pages.homepage": "translation-sw.json",
		"pages.nav": "translation-sw.json",
		"pages.notfound": "translation-sw.json",
		"pages.optin": "translation-sw.json",
		"pages.unsubscribe": "translation-sw.json"
	},
	ta: {
		"pages.homepage": "translation-ta.json",
		"pages.nav": "translation-ta.json",
		"pages.notfound": "translation-ta.json",
		"pages.optin": "translation-ta.json",
		"pages.unsubscribe": "translation-ta.json"
	},
	"ta-IN": {
		"pages.homepage": "translation-ta.json",
		"pages.nav": "translation-ta.json",
		"pages.notfound": "translation-ta.json",
		"pages.optin": "translation-ta.json",
		"pages.unsubscribe": "translation-ta.json"
	},
	te: {
		"pages.homepage": "translation-te.json",
		"pages.nav": "translation-te.json",
		"pages.notfound": "translation-te.json",
		"pages.optin": "translation-te.json",
		"pages.unsubscribe": "translation-te.json"
	},
	"te-IN": {
		"pages.homepage": "translation-te.json",
		"pages.nav": "translation-te.json",
		"pages.notfound": "translation-te.json",
		"pages.optin": "translation-te.json",
		"pages.unsubscribe": "translation-te.json"
	},
	ti: {
		"pages.homepage": "translation-ti.json",
		"pages.nav": "translation-ti.json",
		"pages.notfound": "translation-ti.json",
		"pages.optin": "translation-ti.json",
		"pages.unsubscribe": "translation-ti.json"
	},
	"ti-ER": {
		"pages.homepage": "translation-ti.json",
		"pages.nav": "translation-ti.json",
		"pages.notfound": "translation-ti.json",
		"pages.optin": "translation-ti.json",
		"pages.unsubscribe": "translation-ti.json"
	},
	"tl-PH": {
		"pages.homepage": "translation-fil.json",
		"pages.nav": "translation-fil.json",
		"pages.notfound": "translation-fil.json",
		"pages.optin": "translation-fil.json",
		"pages.unsubscribe": "translation-fil.json"
	},
	tr: {
		"pages.homepage": "translation-tr.json",
		"pages.nav": "translation-tr.json",
		"pages.notfound": "translation-tr.json",
		"pages.optin": "translation-tr.json",
		"pages.unsubscribe": "translation-tr.json"
	},
	"tr-TR": {
		"pages.homepage": "translation-tr.json",
		"pages.nav": "translation-tr.json",
		"pages.notfound": "translation-tr.json",
		"pages.optin": "translation-tr.json",
		"pages.unsubscribe": "translation-tr.json"
	},
	uk: {
		"pages.homepage": "translation-uk.json",
		"pages.nav": "translation-uk.json",
		"pages.notfound": "translation-uk.json",
		"pages.optin": "translation-uk.json",
		"pages.unsubscribe": "translation-uk.json"
	},
	"uk-UA": {
		"pages.homepage": "translation-uk.json",
		"pages.nav": "translation-uk.json",
		"pages.notfound": "translation-uk.json",
		"pages.optin": "translation-uk.json",
		"pages.unsubscribe": "translation-uk.json"
	},
	und: {
		"pages.homepage": "translation.json",
		"pages.nav": "translation.json",
		"pages.notfound": "translation.json",
		"pages.optin": "translation.json",
		"pages.unsubscribe": "translation.json"
	},
	ur: {
		"pages.homepage": "translation-ur.json",
		"pages.nav": "translation-ur.json",
		"pages.notfound": "translation-ur.json",
		"pages.optin": "translation-ur.json",
		"pages.unsubscribe": "translation-ur.json"
	},
	"ur-PK": {
		"pages.homepage": "translation-ur.json",
		"pages.nav": "translation-ur.json",
		"pages.notfound": "translation-ur.json",
		"pages.optin": "translation-ur.json",
		"pages.unsubscribe": "translation-ur.json"
	},
	vi: {
		"pages.homepage": "translation-vi.json",
		"pages.nav": "translation-vi.json",
		"pages.notfound": "translation-vi.json",
		"pages.optin": "translation-vi.json",
		"pages.unsubscribe": "translation-vi.json"
	},
	"vi-VN": {
		"pages.homepage": "translation-vi.json",
		"pages.nav": "translation-vi.json",
		"pages.notfound": "translation-vi.json",
		"pages.optin": "translation-vi.json",
		"pages.unsubscribe": "translation-vi.json"
	},
	zh: {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json",
		"pages.notfound": "translation-zh.json",
		"pages.optin": "translation-zh.json",
		"pages.unsubscribe": "translation-zh.json"
	},
	"zh-CN": {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json",
		"pages.notfound": "translation-zh.json",
		"pages.optin": "translation-zh.json",
		"pages.unsubscribe": "translation-zh.json"
	},
	"zh-TW": {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json",
		"pages.notfound": "translation-zh.json",
		"pages.optin": "translation-zh.json",
		"pages.unsubscribe": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
